export default "<app-pending-suspended></app-pending-suspended>"